<template>
    <div class="drug-cards">
        <!-- 药材卡片网格 -->
        <div class="drug-cards-grid" v-if="drugItems.length > 0">
            <div class="drug-card" v-for="(item, idx) in drugItems" :key="'d-' + idx">
                <span class="dc-index">{{ item.indexText }}</span>
                <span class="dc-name">{{ item.name }}</span>
                <span class="dc-weight">{{ item.value }}<em>{{ isChaowei ? '包' : 'g' }}</em></span>
            </div>
        </div>
        <p class="drug-cards-empty" v-else>暂无药材明细</p>

        <!-- 有效使用期（置于药材汇总上方） -->
        <div class="drug-validity" v-if="config.showSupplyDays !== false">
            <template v-if="consultInfo.ganZhiPrescriptionHourRange && config.showGanZhi">
                有效使用期：<b>{{ pane.startDate }} {{ consultInfo.ganZhiPrescriptionHourRange }}</b>
            </template>
            <template v-else>
                有效使用期：<b>{{ pane.startDate }} ~ {{ pane.endDate }}<template
                        v-if="pane.supplyDays != null">，{{ isChaowei ? '该方案' : '该处方' }}有效期{{ pane.supplyDays }}天</template>。</b>
            </template>
        </div>

        <!-- 医嘱提示（与有效使用期同字号、同红色） -->
        <p class="drug-validity-note">请在专业医生指导下服药</p>

        <!-- 汇总 -->
        <div class="drug-summary">
            <div class="ds-cell">
                <span class="ds-label">药材数量</span>
                <span class="ds-value">{{ pane.count }}<em>{{ isChaowei ? '种' : '味' }}</em></span>
            </div>
            <div class="ds-cell">
                <span class="ds-label">{{ isChaowei ? '参考总数量' : '参考总重量' }}</span>
                <span class="ds-value">{{ pane.totalWeight }}<em>{{ isChaowei ? '包' : 'g' }}</em></span>
            </div>
            <div class="ds-cell" v-if="pane.charge != 0 && !pane.isHandmade">
                <span class="ds-label">{{ isChaowei ? '参考价格' : '参考总药价' }}</span>
                <span class="ds-value">{{ pane.charge }}<em>元/副</em></span>
            </div>
        </div>

        <!-- 自拟/颗粒方：饮片重量汇总 -->
        <div class="drug-summary drug-summary-sub"
            v-if="pane.isHandmade && (pane.decoctionTotalWeight || pane.totalWeight)">
            <div class="ds-cell">
                <span class="ds-label">饮片重量</span>
                <span class="ds-value">{{ pane.decoctionTotalWeight || pane.totalWeight }}<em>克</em></span>
            </div>
            <div class="ds-cell" v-if="(pane.decoctionPrice || pane.charge) != 0">
                <span class="ds-label">参考药价</span>
                <span class="ds-value">{{ pane.decoctionPrice || pane.charge }}<em>元/副</em></span>
            </div>
        </div>

        <!-- 自拟/颗粒方：颗粒重量汇总 -->
        <div class="drug-summary drug-summary-sub"
            v-if="pane.isHandmade && config.showGranules && pane.granulesTotalWeight">
            <div class="ds-cell">
                <span class="ds-label">颗粒重量</span>
                <span class="ds-value">{{ pane.granulesTotalWeight }}<em>克</em></span>
            </div>
            <div class="ds-cell" v-if="pane.granulesSumPrice != 0">
                <span class="ds-label">参考药价</span>
                <span class="ds-value">{{ pane.granulesSumPrice }}<em>元/副</em></span>
            </div>
        </div>

        <!-- <p class="drug-disclaimer">以上价格与用量仅供参考，实际用量与费用以最终处方及审核结果为准。</p> -->

    </div>
</template>

<script>
export default {
    name: 'PrescriptionTable',
    props: {
        pane: { type: Object, default: () => ({}) },
        consultInfo: { type: Object, default: () => ({}) },
        config: {
            type: Object,
            default: () => ({
                showSupplyDays: true,
                chaoweiMode: false,
            }),
        },
    },
    computed: {
        // 是否超微饮品场景（替换表头/汇总/有效期文案）
        isChaowei() {
            return !!(this.config && this.config.chaoweiMode);
        },
        // 将两两配对的药材展开为顺序卡片列表
        drugItems() {
            const items = [];
            const options = (this.pane && this.pane.options) || [];
            for (let i = 0; i < options.length; i++) {
                const opt = options[i];
                if (!opt) continue;
                if (opt.key) {
                    items.push({
                        indexText: this.fmtIndex(opt.index, items.length + 1),
                        name: opt.key,
                        value: opt.value,
                    });
                }
                if (opt.key1 != null && opt.key1 !== '') {
                    items.push({
                        indexText: this.fmtIndex(opt.index1, items.length + 1),
                        name: opt.key1,
                        value: opt.value1,
                    });
                }
            }
            return items;
        },
    },
    methods: {
        fmtIndex(index, fallback) {
            let n = index;
            if (n == null || n === '') n = fallback;
            const s = String(n);
            return s.length < 2 ? '0' + s : s;
        },
    },
}
</script>

<style scoped>
/* ========== 药材卡片网格 ========== */
.drug-cards {
    width: 100%;
}

.drug-cards-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
}

.drug-card {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 14px;
    border: 1px solid #e8f0ee;
    border-radius: 12px;
    background: #fff;
    transition: all 0.2s ease;
}

.drug-card:hover {
    border-color: #b7ddd8;
    background: #f7fcfb;
}

.dc-index {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 1px solid #009798;
    color: #009798;
    font-size: 16px;
    font-weight: 700;
}

.dc-name {
    flex: 1;
    min-width: 0;
    font-size: 17px;
    font-weight: 600;
    color: #304744;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.dc-weight {
    flex-shrink: 0;
    font-size: 17px;
    font-weight: 700;
    color: #009798;
}

.dc-weight em {
    font-style: normal;
    font-size: 16px;
    font-weight: 500;
    margin-left: 2px;
}

.drug-cards-empty {
    margin: 0;
    padding: 26px 0;
    text-align: center;
    font-size: 16px;
    color: #a7b8b4;
}

/* ========== 汇总 ========== */
.drug-summary {
    display: flex;
    margin-top: 18px;
    border-radius: 12px;
    background: #f1f7f5;
    overflow: hidden;
}

.drug-summary-sub {
    margin-top: 12px;
}

.ds-cell {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 16px 20px;
}

.ds-cell+.ds-cell {
    border-left: 1px solid #e2ede9;
}

.ds-label {
    font-size: 16px;
    color: #7f9994;
}

.ds-value {
    font-size: 24px;
    font-weight: 700;
    color: #304744;
    line-height: 1.2;
}

.ds-value em {
    font-style: normal;
    font-size: 16px;
    font-weight: 500;
    color: #7f9994;
    margin-left: 3px;
}

/* ========== 免责说明 / 有效期 ========== */
.drug-disclaimer {
    margin: 14px 0 0;
    font-size: 16px;
    line-height: 1.6;
    color: #9aa8a3;
}

/* 有效使用期：位于药材汇总上方，红色提示 */
.drug-validity {
    margin-top: 18px;
    font-size: 16px;
    line-height: 1.7;
    color: #e02e2e;
}

.drug-validity b {
    color: #e02e2e;
}

/* 医嘱提示：字号/行高/颜色与「有效使用期」保持一致 */
.drug-validity-note {
    margin: 8px 0 0;
    font-size: 16px;
    line-height: 1.7;
    color: #e02e2e;
}

/* ========== 响应式 ========== */
@media (max-width: 1024px) {
    .drug-cards-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 640px) {
    .drug-cards-grid {
        grid-template-columns: 1fr;
    }

    .drug-summary {
        flex-direction: column;
    }

    .ds-cell+.ds-cell {
        border-left: none;
        border-top: 1px solid #e2ede9;
    }
}
</style>
